<template>
  <div class="page box">
    <div  >
      <van-sticky class="sticky">
<div>
<studentTitleCard  isChange @change="studentChange"/>
</div>
</van-sticky>
    
    <div class="center">
        <div class="center_text" @click="onReport()">体测报告 <van-icon name="arrow" /></div>
         
        <img height="100%" width="100%" style="border-radius: 8px;object-fit: cover;" :src="require('@/assets/image/体测报告btn.jpg')" alt="">
    </div>
    <div class="center">
        <div  class="center_text" @click="onbodyReport()">锻炼报告 <van-icon name="arrow" /></div>
        <img height="100%" width="100%" style="border-radius: 8px;object-fit: cover;" :src="require('@/assets/image/锻炼报告btn.jpg')" alt="">
    </div>


 <!-- <div class="center"  v-for="(item,i) in yearList" :key="i">
<div >
    <div class="noActiceCard">
      <van-row gutter="20">
      <van-col span="8" class="text_l">
        <van-image fit="contain" :src="require('@/assets/image/预约体测.png')"/>
      </van-col>
      <van-col span="16" class="text_l">
        <h2>{{item.name}}</h2>
        <div style="margin-bottom:10px;"> {{item.startTime||''}} ~ {{item.endTime||''}}</div>
        <div style="display:flex;justify-content: space-between;">
            <div>
                <van-button type="warning"  size="small" @click="onReport(item)">体测报告 ></van-button>
                <van-button type="warning"  size="small" style="margin-left:10px;" @click="onbodyReport(item)">锻炼报告 ></van-button>
            </div>
        </div>
      </van-col>
    </van-row>
    </div>
</div>
    </div> -->

    </div>

  </div>

</template>

<script>
import CustomButton from "@/components/CustomButton.vue";
import { getChildInfoList} from "@/api/studentBind.js";
import { checkOrder,getEduYearList} from "@/api/resultReporting.js";
import studentTitleCard from "@/components/studentTitleCard.vue";
 import { setSession ,getSession} from "@/utils/cookie";

import store from '@/store'
export default {
data () {
    return {
        childInfoList:[],
        studentInfo:{},
        active:'0',
        yearList:[],
        studentTitleInfo:{}
    }
},
components: {
  CustomButton ,
  studentTitleCard
},
mounted () {
    this.init()
  
},
methods:{
  studentChange(val){
    console.log('val',val);
    this.studentTitleInfo =val
      this.getEduYearList()
      this.checkOrder()
  },
  onReport(){
      let data = JSON.stringify({...this.studentTitleInfo,
    //        termName: item.name,
    //   termCode:item.code,
      })
        this.$router.push({path:'fitnessReport',query:{data:data}})
  },
  onbodyReport(){
      let data = JSON.stringify({...this.studentTitleInfo,
          //  termName: item.name,
      // termCode:item.code,
      })
        this.$router.push({path:'bodyForging',query:{data:data}})
  },
    onAddAppoint(item){
       let data = {
            snCode:this.studentTitleInfo.snCode,
            schoolCode:this.studentTitleInfo.schoolCode,
            termName: item.name,
            termCode:item.code,
          }
        this.$router.push({path:'reportingList',query:data})
    },
  
    init(){
          getChildInfoList({status:'1'}).then(res=>{
        console.log(res);
        this.childInfoList = res.data.data||[]
        // if (this.childInfoList.length>0) {
        // this.studentTitleInfo =  JSON.parse(getSession('studentTitleCard'))


        //  this.checkOrder()
        //  this.getEduYearList()
        // }
        })
      
    },
    checkOrder(){
        checkOrder({
            snCode:this.studentTitleInfo.snCode,
            schoolCode:this.studentTitleInfo.schoolCode,
          }).then(res=>{
            // 检查是否有准考证
            console.log(res);
            if (!+res.data.body) {
                // 没有准考证
                this.$dialog
                .alert({
                message: '请先申请电子准考证！！',
                showCancelButton: false
                }).then(() => {
                    this.$router.push({path:'admissionTicket'})
                })
        
            }   
            // res.body
          })
    },
    getEduYearList(){
        getEduYearList({
            snCode:this.studentTitleInfo.snCode,
            schoolCode:this.studentTitleInfo.schoolCode,
          }).then(res=>{
            this.yearList = res.data.data
          })
    },
    OnaddFaceIn(){
        if (!this.studentInfo.faceData||this.studentInfo.faceData=='') {
            this.$notify({ type: "danger", message: '请拍摄证件照！' });
            return
        }
        this.$dialog
        .alert({
          message: '是否确认生成准考证?',
          showCancelButton: true
        })
        .then(() => {
            insertIntoFaceData(this.studentInfo).then(Res=>{
            this.$notify({ type: "success", message: '生成成功！' });
            this.$router.back(-1)
            })
        })
        .catch(() => {
          // on cancel
        })
    },
   
}
}
</script>

<style lang="less" scoped>
.box{
    padding: 5px;
}
.text_l{
    text-align: left;
    text-overflow:ellipsis;
    overflow:hidden;
    font-size: 3vw;
    // white-space:nowrap;
    
}
.noActiceCard{
    position: relative;
 .ifActiveBox{
          position: absolute;
          right: 0px;
          top: 10px;
          transform: rotate(45deg);
        }
}

 .center{
        height: 100px;
        line-height: 100px;
        text-align: center;
        position: relative;
        background-color: #fff;
        border-radius:8px;
        margin: 8px;
        box-shadow: 2px 2px 3px 3px rgba(226, 225, 225, 0.6);
        object-fit: cover;
        .center_text{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            font-size: 20px;
            font-weight: 700;
            color: #458ff1b9;
        }
        .center_value{
            color: #bbb;
        }
    
    

    
    }
</style>